module.exports = __webpack_public_path__ + "static/images/calendar-light.1731667a0c382d9226a62412cef04afd.svg";